import { useState } from 'react'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import Grid from '@mui/material/Grid'

import './WebCodeConfirmationBox.sass'

export type WebCodeConfirmationBoxType = 'softDeleteWebCode'

export type WebCodeConfrimationBoxProps = {
    type?: WebCodeConfirmationBoxType
    title?: string
}

export type WebCodeConfrimationBoxDispatch = {
    confirmFn?: () => void
    closeFn: () => void
}

export interface WebCodeConfirmationBoxParams {
    type: WebCodeConfirmationBoxType
    callback: () => void
    title?: string
}

type Props = WebCodeConfrimationBoxProps & WebCodeConfrimationBoxDispatch

const WebCodeConfirmationBox = ({ title, type, confirmFn, closeFn }: Props) => {
    const [isButtonDisabled, setIsButtonDisabled] = useState(false)

    const buildText = () => {
        switch (type) {
            case 'softDeleteWebCode':
                return (
                    <>
                        <Grid
                            container={true}
                            spacing={2}
                            className="title"
                            wrap="wrap"
                            alignItems="center"
                            justifyContent="center"
                            direction="column"
                        >
                            <Grid item={true}>
                                <i className="material-icons red">warning</i>
                            </Grid>
                            <div className="text">
                                <div>Are you sure you want to delete</div>
                                <div>this Webchat web code?</div>
                            </div>
                        </Grid>
                    </>
                )

            default:
                return null
        }
    }

    const buildConfirmBtn = () => {
        const onConfirm = async () => {
            setIsButtonDisabled(true)
            confirmFn && (await confirmFn())
            setIsButtonDisabled(false)
            closeFn()
        }
        switch (type) {
            case 'softDeleteWebCode':
                return (
                    <Button color="primary" variant="contained" onClick={onConfirm}>
                        Delete
                    </Button>
                )
            default:
                return null
        }
    }

    return (
        <div className="confirmation-container">
            <div className="confirmation-inner-container">
                {buildText()}
                <Grid container={true} spacing={2} className="buttons-container" justifyContent="center">
                    <Grid item={true}>
                        <Button variant="outlined" onClick={closeFn}>
                            Cancel
                        </Button>
                    </Grid>
                    <Grid item={true}>{buildConfirmBtn()}</Grid>
                    {isButtonDisabled && (
                        <div className="circular-progress-loader">
                            <CircularProgress size={48} />
                        </div>
                    )}
                </Grid>
            </div>
        </div>
    )
}

export default WebCodeConfirmationBox
